import { useElements, useStripe, CardElement } from "@stripe/react-stripe-js";
import React, { useEffect, useState } from "react";
import CurrencyFormat from "react-currency-format";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import axios from "../config/axios";
import { firestoreDB } from "../config/firebase";
import { getBasketTotal, getUserLocation } from "../app/functions";
import { clearBasket, selectBasket } from "../features/basketSlice";
import { selectUser } from "../features/userSlice";
import CheckoutProduct from "./CheckoutProduct";
import "./Payment.css";
import Loader from "react-loader-spinner";

function Payment() {
  const user = useSelector(selectUser);
  const basket = useSelector(selectBasket);
  const history = useHistory();

  const stripe = useStripe();
  const elements = useElements();

  const [succeeded, setSucceeded] = useState(false);
  const [processing, setProcessing] = useState("");
  const [error, setError] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [clientSecret, setClientSecret] = useState("");
  const [errorLoading, setErrorMsg] = useState(
    "Could not determine your address, please provide access to your location."
  );

  const [loading, setLoading] = useState(false);
  const [loadingError, showErrorLoading] = useState(false);

  const [location, setLocation] = useState({
    address: "",
    country: "",
    county: "",
  });

  const dispatch = useDispatch();

  useEffect(() => {
    const getClientSecret = async () => {
      const response = await axios({
        method: "POST",
        url: `/payments/create?total=${getBasketTotal(basket) * 100}`,
      });
      setClientSecret(response.data.clientSecret);
    };
    if ("geolocation" in navigator) {
      setLoading(true);
      navigator.geolocation.getCurrentPosition(
        async function (position) {
          await getUserLocation(
            position.coords.latitude,
            position.coords.longitude
          )
            .then((data) => {
              console.log(data);
              return setLocation({
                country: data.data.data[0].country,
                address: data.data.data[0].name,
                county: data.data.data[0].county,
              });
            })
            .catch((err) => {
              setLoading(false);
              showErrorLoading(true);
              setErrorMsg(
                "Access Restricted - Subscription does not support HTTPS Encryption."
              );
            })
            .finally(() => {
              setLoading(false);
              showErrorLoading(false);
            });
        },
        (err) => {
          setLoading(false);
          showErrorLoading(true);
        }
      );
    } else {
      setLoading(false);
      showErrorLoading(true);
      setErrorMsg(
        "Access Restricted - Subscription does not support HTTPS Encryption."
      );
    }
    getClientSecret();
  }, [basket]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setProcessing(true);

    const payload = await stripe
      .confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement),
        },
      })
      .then(({ paymentIntent }) => {
        console.log(paymentIntent);
        firestoreDB
          .collection("users")
          .doc(user?.uid)
          .collection("orders")
          .doc(paymentIntent.id)
          .set({
            basket: basket,
            amount: paymentIntent.amount,
            created: paymentIntent.created,
          });
        setSucceeded(true);
        setError(null);
        setProcessing(false);
        dispatch(clearBasket());
        history.push("/orders");
      })
      .catch((err) => console.log(err));
  };

  console.log("THE SECRET IS: ", clientSecret);

  const handleChange = (e) => {
    setDisabled(e.empty);
    setError(e.errror ? e.error.message : "");
  };

  return (
    <div className="payment">
      <div className="payment__container">
        <h1>
          Checkout (<Link to="/checkout">{basket?.length} items)</Link>
        </h1>
        <div className="payment__section">
          <div className="payment__title">
            <h3>Delivery Address</h3>
          </div>
          <div className="payment__address">
            <p>{user?.email}</p>
            {location?.address || location?.county ? (
              <>
                <p>
                  {location?.address}, {location?.county}
                </p>
                <p>{location?.country}</p>
              </>
            ) : loading ? (
              <Loader
                type="Oval"
                color="#f0c14b"
                height={20}
                width={20}
                visible={loading}
                // timeout={3000} //3 secs
              />
            ) : (
              loadingError && <p>{errorLoading}</p>
            )}
          </div>
        </div>
        <div className="payment__section">
          <div className="payment__title">
            <h3>Review Items & Delivery</h3>
          </div>
          <div className="payment__items">
            {basket.map((item) => {
              return (
                <CheckoutProduct
                  key={item.id}
                  id={item.id}
                  title={item.title}
                  price={item.price}
                  image={item.image}
                  rating={item.rating}
                />
              );
            })}
          </div>
        </div>
        <div className="payment__section">
          <div className="payment__title">
            <h3>Payment Method</h3>
          </div>

          <div className="payment__details">
            <form onSubmit={handleSubmit}>
              <CardElement onChange={handleChange} />
              <div className="payment__priceContainer">
                <CurrencyFormat
                  renderText={(value) => (
                    <>
                      <h3>Order Total: {value}</h3>
                    </>
                  )}
                  decimalScale={2}
                  value={getBasketTotal(basket)} // Part of the homework
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"$"}
                />
                <button
                  type="submit"
                  disabled={processing || disabled || succeeded}
                >
                  <span>{processing ? <p>Processing</p> : "Buy Now"} </span>
                </button>
              </div>
              {error && <div>{error}</div>}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Payment;
